/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { GradeSimulationTccItemViewModel } from "../types/GradeSimulationTccItemViewModel.ts";

export const gradeSimulationTccItemViewModelSchema = z.object({
  name: z.string().nullish(),
  grade: z.optional(z.number()),
}) as unknown as ToZod<GradeSimulationTccItemViewModel>;
